// SuperAdmin (Deccos management) tenant CompagnyID.
// Used to gate template management UI affordances; not a role check.
export const SUPER_ADMIN_TENANT = '123423HJKHVKH'

/**
 * @param {string | null | undefined} compagnyId
 * @returns {boolean}
 */
export const isSuperAdminTenant = (compagnyId) => compagnyId === SUPER_ADMIN_TENANT

export default isSuperAdminTenant
